import { render, staticRenderFns } from "./DocumentEditCreate.vue?vue&type=template&id=e02ebea6&"
import script from "./DocumentEditCreate.vue?vue&type=script&lang=js&"
export * from "./DocumentEditCreate.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEditCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports